import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import DefaultTextBold from "../../../../components/Accessibility/DefaultTextBold"
import { Prestador } from "../../../../interfaces/entities/SaudeBemEstar/Agendamento/Prestador"
import React, { ReactNode } from "react"
import { faUserDoctor } from "@fortawesome/pro-duotone-svg-icons"
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext"
import DefaultText from "../../../../components/Accessibility/DefaultText"
import WhiteContainer from "../../../../components/Accessibility/WhiteContainer"
import { SxProps, Typography } from "@mui/material"

const sxStyleTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
	fontWeight: 700,
  fontSize: "20px",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left",
  color: "#383838",
  textWrap: 'wrap',
  '@media(max-width: 799px)': {
    width: '100%'
  },
	marginBottom: '10px'

}

const PrestadorCard: React.FC<{prestador: Prestador, button: ReactNode, showTitle?: boolean}> = ({ prestador, button, showTitle }) => {

	const accessibility = useAccessibility();
	return (
		<WhiteContainer shadow style={{ width: '100%', padding: '32px'}} className="flex-mobile gap-20 align-start" tabIndex={0}>
				<FontAwesomeIcon icon={faUserDoctor} style={{...accessibility.contrastColorAccessibility}} className="fa-icon32x32" />
				<div className="flex-col gap-16 align-start box-content-text">
					{ showTitle && <Typography sx={sxStyleTitle} style={accessibility.textStyleAccessibility}>Profissional selecionado(a):</Typography> }
					<DefaultTextBold text={prestador.nome}/>
					<DefaultText text={`<b>Especialidade:</b> ${prestador.especialidade}`} />
					<DefaultText text={prestador.curriculo || ''} />
					<DefaultText text={`<b>Provável disponibilidade:</b> ${prestador.dtProvavelDisponibilidade || 'Sem data'}`} />
					{ button }
				</div>
			</WhiteContainer>
	)
}

export default PrestadorCard;